import React from 'react';
import { Link } from 'react-router-dom';
import './HomeIntro.css';
import { projectsForIntro } from '../data/projects';

const EMAIL = 'sjderham@protonmail.com';

// TODO (Sean): replace the placeholder LinkedIn URL with your real profile.
const LINKEDIN_URL = '#';

const HomeIntro = () => {
  return (
    <aside className="home-intro">
      <div className="home-intro__block">
        <h1 className="home-intro__name">Sean Derham</h1>
        <p className="home-intro__meta">
          <span className="home-intro__role">
            <span className="material-symbols-outlined home-intro__meta-icon" aria-hidden="true">
              deployed_code
            </span>
            Designer &amp; Developer
          </span>
          <br />
          <span className="home-intro__role">
            <span className="material-symbols-outlined home-intro__meta-icon" aria-hidden="true">
              location_on
            </span>
            London, UK
          </span>
        </p>
      </div>

      <div className="home-intro__block">
        <span className="pill pill--label">About</span>
        <p className="home-intro__about">
          Designer and developer with four years delivering brand, motion and
          digital work for clients, from concept through to launch. I craft
          immersive visuals and brand-driven experiences across motion
          graphics, interactive design and web, and use AI as leverage in
          production. Comfortable owning a project end to end. Founder of{' '}
          <a
            href="https://www.keymotion.ai/"
            target="_blank"
            rel="noopener noreferrer"
          >
            keymotion.ai
          </a>
          , an AI motion graphics editor built for editors.
        </p>
      </div>

      <div className="home-intro__block">
        <span className="home-intro__label">Selected Work</span>
        <div className="home-intro__tags">
          {projectsForIntro.map((project) => (
            <Link key={project.to} to={project.to} className="pill pill--link">
              {project.title}
            </Link>
          ))}
          <Link to="/showreel" className="pill pill--link">
            Motion Showreel
          </Link>
        </div>
      </div>

      <div className="home-intro__block">
        <span className="home-intro__label">Contact</span>
        <div className="home-intro__tags">
          <a className="pill pill--link" href={`mailto:${EMAIL}`}>
            Email
          </a>
          <a
            className="pill pill--link"
            href={LINKEDIN_URL}
            target="_blank"
            rel="noreferrer"
          >
            LinkedIn
          </a>
        </div>
      </div>
    </aside>
  );
};

export default HomeIntro;
